import { render, staticRenderFns } from "./AltaSimpatizanteSga.vue?vue&type=template&id=cb21a692"
import script from "./AltaSimpatizanteSga.vue?vue&type=script&setup=true&lang=js"
export * from "./AltaSimpatizanteSga.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports